import { useState } from "react";
import StockQuoteTabContent from "./StockQuoteTabContent"; // Import the stock quote component
import { Button } from "@heroui/button";
import RatiosTab from "./RatiosTabs";
import PriceTarget from "@/src/components/companies/PriceTarget";
import DividendRatios from "./DividendRatios";
import EarningsCalendar from "./EarningsCalendar";

export default function QuoteTab({ stockSymbol }) {
  const [activeTab, setActiveTab] = useState("Stock Quote");

  const renderTabContent = () => {
    switch (activeTab) {
      case "Stock Quote":
        return <StockQuoteTabContent stockSymbol={stockSymbol} />;
      case "Ratios Analysis":
        return <RatiosTab stockSymbol={stockSymbol} />;
      case "Dividend & Yield":
        return <DividendRatios stockSymbol={stockSymbol} />;
      case "Earnings Date":
        return <EarningsCalendar stockSymbol={stockSymbol} />;
      // case "Analysts Target":
      //   return <PriceTarget stockSymbol={stockSymbol} />;
      default:
        return null;
    }
  };

  return (
    <div className="flex flex-col  lg:flex-row">
      <div className="lg:w-1/4">
        {/* Mobile Tabs - Horizontal Scroll */}
        <div className="lg:hidden overflow-x-auto mt-3 mr-3 pl-4 whitespace-nowrap md:w-96">
          {[
            "Stock Quote",
            "Ratios Analysis",
            "Dividend & Yield",
            "Earnings Date",
            // "Analysts Target",
          ].map((tabName) => (
            <Button
              key={tabName}
              onClick={() => setActiveTab(tabName)}
              className={`rounded-xl mr-2 mt-2 mb-4 text-left whitespace-nowrap ${
                activeTab === tabName ? "bg-1B51CA text-white" : ""
              }`}
            >
              {tabName}
            </Button>
          ))}
        </div>
        {/* Desktop Tabs - Vertical List */}
        <div className="hidden lg:flex flex-col border-r justify-center h-300">
          {[
            "Stock Quote",
            "Ratios Analysis",
            "Dividend & Yield",
            "Earnings Date",
            // "Analysts Target",
          ].map((tabName) => (
            <Button
              variant="light"
              size="sm"
              key={tabName}
              onClick={() => setActiveTab(tabName)}
              className={`mb-1 ${
                activeTab === tabName ? "bg-1B51CA text-white" : ""
              }`}
            >
              {tabName}
            </Button>
          ))}
        </div>
      </div>
      <div className="flex-1 p-5 items-center">{renderTabContent()}</div>
    </div>
  );
}
